import { Config } from "@app/config";
import { http } from "@shared/ui";
import type { CreditInsuranceRequest, CreditInsuranceResponse, FormFields } from "./types";

export function calculate(values: FormFields): Promise<CreditInsuranceResponse> {
	const request: CreditInsuranceRequest = {
		birthYear: values.birthYear,
		durationYears: values.durationYears,
		collateralAmount: values.collateralAmount,
	};

	return http.post(Config.getApiUrl("/api/public/credit-insurance/calculate"), request);
}
